<script setup lang="ts">
// Mask a pending reading while its text still reserves the final line height.
// The caller supplies a representative hidden value; it is never announced.
defineProps<{ loading?: boolean }>();
</script>

<template>
  <span class="relative inline-block align-bottom">
    <span :class="{ invisible: loading }" :aria-hidden="loading || undefined"
      ><slot />
    </span>
    <span
      v-if="loading"
      aria-hidden="true"
      class="absolute inset-x-0 inset-y-[15%] rounded-md bg-app-border motion-safe:animate-pulse"
    />
  </span>
</template>
